// extracted by mini-css-extract-plugin
module.exports = {"container":"ReturnIconButton-container-3A7ur","text":"ReturnIconButton-text-Qfs4y"};